"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const apiOrderToAppOrder_1 = __importDefault(require("../../libs/apiOrderToAppOrder"));
const appBatchToApiBatch_1 = __importDefault(require("../../libs/appBatchToApiBatch"));
class OrderApi {
    constructor(api) {
        this.api = api;
    }
    getOrder(orderId) {
        return __awaiter(this, void 0, void 0, function* () {
            const endpoint = `/c/order/${orderId}`;
            const response = yield this.api.axiosGo.get(endpoint);
            return (0, apiOrderToAppOrder_1.default)(response.data);
        });
    }
    getOrders({ merchantId, table, status, isFilteredByMe = false, limit = 10, valid = 'true,false', withinCutoffTime = false, hideEmpty = true, }) {
        return __awaiter(this, void 0, void 0, function* () {
            const endpoint = '/c/order';
            const params = Object.assign(Object.assign({ me: isFilteredByMe, merchantID: merchantId, table,
                status,
                valid, page: 1, size: limit }, withinCutoffTime && { withinCutoffTime: true }), { hideEmpty });
            const response = yield this.api.axiosGo.get(endpoint, { params });
            return response.data.map(apiOrderToAppOrder_1.default);
        });
    }
    createOrder(data) {
        return __awaiter(this, void 0, void 0, function* () {
            const endpoint = '/c/order';
            const response = yield this.api.axiosGo.post(endpoint, data);
            return (0, apiOrderToAppOrder_1.default)(response.data);
        });
    }
    joinOrder(orderId) {
        return __awaiter(this, void 0, void 0, function* () {
            const endpoint = `/c/order/${orderId}/join`;
            const response = yield this.api.axiosGo.post(endpoint);
            return (0, apiOrderToAppOrder_1.default)(response.data);
        });
    }
    submitBatch(params, dataCallback) {
        var _a;
        return __awaiter(this, void 0, void 0, function* () {
            const data = (0, appBatchToApiBatch_1.default)(params);
            if (((_a = data === null || data === void 0 ? void 0 : data.payment) === null || _a === void 0 ? void 0 : _a.payload) != null) {
                // rename payload to data
                data.payment.data = data.payment.payload;
                delete data.payment.payload;
            }
            const endpoint = `/c/order/${params.orderId}/submit`;
            if (dataCallback != null) {
                dataCallback(data);
            }
            const response = yield this.api.axiosGo.post(endpoint, data);
            return (0, apiOrderToAppOrder_1.default)(response.data);
        });
    }
    updatePromoCode(orderId, promoCodeId, deletedPromoCodeId) {
        return __awaiter(this, void 0, void 0, function* () {
            const endpoint = `/c/order/${orderId}/promocode`;
            const response = yield this.api.axiosGo.post(endpoint, { promoCodeId, deletedPromoCodeId });
            return (0, apiOrderToAppOrder_1.default)(response.data);
        });
    }
    deletePromoCode(orderId, promoCodeId) {
        return __awaiter(this, void 0, void 0, function* () {
            const endpoint = `/c/order/${orderId}/promocode/${promoCodeId}`;
            const response = yield this.api.axiosGo.delete(endpoint);
            return (0, apiOrderToAppOrder_1.default)(response.data);
        });
    }
    pay(orderId, payment) {
        return __awaiter(this, void 0, void 0, function* () {
            const endpoint = `/c/order/${orderId}/pay`;
            if (payment.source != null && payment.ref == null) {
                // rename source to ref
                payment.ref = payment.source;
                delete payment.source;
            }
            if (payment.data != null) {
                // rename data to payload
                payment.payload = payment.data;
                delete payment.data;
            }
            const response = yield this.api.axiosGo.put(endpoint, payment);
            return (0, apiOrderToAppOrder_1.default)(response.data);
        });
    }
    cancelPay(orderId, paymentId) {
        return __awaiter(this, void 0, void 0, function* () {
            const endpoint = `/c/order/${orderId}/payment/${paymentId}`;
            const response = yield this.api.axiosGo.delete(endpoint);
            return (0, apiOrderToAppOrder_1.default)(response.data);
        });
    }
    requestPaying(orderId, payment) {
        return __awaiter(this, void 0, void 0, function* () {
            const endpoint = `/c/order/${orderId}/paying`;
            const response = yield this.api.axiosGo.put(endpoint, payment);
            return (0, apiOrderToAppOrder_1.default)(response.data);
        });
    }
    requestService(orderId) {
        return __awaiter(this, void 0, void 0, function* () {
            const endpoint = `/c/order/${orderId}/service`;
            const response = yield this.api.axiosGo.put(endpoint);
            return (0, apiOrderToAppOrder_1.default)(response.data);
        });
    }
    cancelOrder(orderId, reason) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.api.axiosGo.put(`/c/order/${orderId}/cancel`, {
                reason,
            });
            return (0, apiOrderToAppOrder_1.default)(response.data);
        });
    }
    getRecentPaymentInfo() {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.api.axiosGo.get('/c/payment/recent');
            return response.data;
        });
    }
    createWechatPayment(data) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.api.axiosNode.post('/c/payment/qfpay/wechatpay', data);
            return response.data;
        });
    }
    createAliPayment(data) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.api.axiosNode.post('/c/payment/qfpay/alipay', data);
            return response.data;
        });
    }
    createPayMePaymentQfpay(data) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.api.axiosNode.post('/c/payment/qfpay/payme', data);
            return response.data;
        });
    }
    createPayMePayment2c2p(data) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.api.axiosGo.post('/c/payment/2c2p/payme', data);
            return response.data;
        });
    }
    /**
   * @deprecated PayMe 將分為 qfpay 和 2c2p 兩種 gateway，需分別改用 createPayMePaymentQFPay 或 createPayMePayment2c2p
   */
    createPayMePayment(data) {
        return __awaiter(this, void 0, void 0, function* () {
            return yield this.createPayMePaymentQfpay(data);
        });
    }
    createOctopusPayment(data) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.api.axiosNode.post('/c/payment/octopus', data);
            return response.data;
        });
    }
    createRabbitPayPayment(data) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.api.axiosNode.post('/c/payment/rabbitpay', data);
            return response.data;
        });
    }
    validateSession(data) {
        return __awaiter(this, void 0, void 0, function* () {
            const res = yield this.api.axiosNode.post('/c/payment/applepay/validateSession', data);
            return res.data;
        });
    }
    getQFPayOrderStatus(outTradeNumber, type = '', options = {}) {
        var _a;
        return __awaiter(this, void 0, void 0, function* () {
            const from = (_a = options.from) !== null && _a !== void 0 ? _a : '';
            const response = yield this.api.axiosNode.get(`/c/payment/qfpay/enquiry/${outTradeNumber}?type=${type}&from=${from}`, {});
            return response.data;
        });
    }
    /**
   * 轉移匿名帳號下的所有訂單至正式帳號
   * 不確定 response 是什麼
   * @param anonymousToken
   */
    transferAnonymousOrders(token, anonymousToken) {
        return __awaiter(this, void 0, void 0, function* () {
            const data = { token }; // 正式帳號的 token
            const config = { headers: { Authorization: 'Bearer ' + anonymousToken } };
            const response = yield this.api.axiosGo.post('/c/transferowner', data, config);
            return response.data;
        });
    }
    claimCRMPoints(orderId, password) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.api.axiosGo.post(`/c/order/${orderId}/claimpoint`, { password });
            return (0, apiOrderToAppOrder_1.default)(response.data);
        });
    }
}
exports.default = OrderApi;
//# sourceMappingURL=Order.js.map